// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 308 ? "devtools" : chunkId) + "." + {"308":"bf418b45","497":"ba6a4c12"}[chunkId] + ".chunk.js";
};